export const getUserTier = () => {
  // Returns 'free' at launch
  // Replace internals when wiring payments
  return 'free'
}

export const isPro = () => getUserTier() === 'pro'
